import React from 'react'

export const Page404 = () => {
  return (
    <div>
      <h1>Page 404</h1>
    </div>
  )
}
